import React from 'react';
import logo from 'assets/Tammilanit 2027-logo.png';
import CountDownClock from './CountDownClock';
import { useNavigate } from 'react-router-dom';
import { Container, Grid, Image, Title } from '@mantine/core';
import config from 'config/config';
import { useSettings } from 'hooks/useSettings';

const AppHeader: React.FC = () => {
    const navigate = useNavigate();
    const { settings } = useSettings();
    const logoPath = settings?.logoPath || 'assets/Tammilanit 2026-logo.png';
    
    // Try to dynamically import the logo, fallback to default
    let logoSrc = logo;
    try {
        if (settings?.logoPath) {
            // In a real implementation, you'd need to handle dynamic imports properly
            // For now, we'll use the default logo
            logoSrc = logo;
        }
    } catch {
        logoSrc = logo;
    }
    
    return (
        <header
            className="app-header"
            onClick={() => {
                navigate('/');
            }}
        >
            <Container>
                {/* Desktop layout */}
                <Grid align="center" visibleFrom="sm">
                    <Grid.Col span={1}>
                        <Title className="page-title" order={1}></Title>
                    </Grid.Col>
                    <Grid.Col span={10} style={{ display: 'flex', justifyContent: 'center' }}>
                        <Image src={logoSrc} alt="logo" className="logo" style={{ maxHeight: 100, width: 'auto' }} />
                    </Grid.Col>
                    <Grid.Col span={1}>
                        <CountDownClock disabled={config.REGISTRATION_OPEN !== 'true'} />
                    </Grid.Col>
                </Grid>
                {/* Mobile layout */}
                <Grid align="center" hiddenFrom="sm">
                    <Grid.Col span={12}>
                        <Image src={logo} alt="logo" style={{ maxHeight: 100 }} />
                    </Grid.Col>
                </Grid>
            </Container>
        </header>
    );
};

export default AppHeader;
